import React from 'react'
import { Switch } from 'react-router-dom'
// import { Route } from 'react-router'
import Loadable from './Loadable'
import { PublicRoute, PrivateRoute } from '../../../lib/routePermission'

const AsyncHome = Loadable({
    loader: () => import('../../home/components/pages/Home')
})

const AsyncNotFound = Loadable({
    loader: () => import('../../auth/components/pages/NotFound')
})

const AsyncNoPer = Loadable({
    loader: () => import('../../auth/components/pages/NoPer')
})

const AsyncLogin = Loadable({
    loader: () => import('../../auth/components/pages/Login')
})

//CUSTOMER
const AsyncAllCustomer = Loadable({
    loader: () => import('../../customer/components/pages/AllCustomer')
})
const AsyncCreateCustomer = Loadable({
    loader: () => import('../../customer/components/pages/CreateCustomer')
})
const AsyncUpdateCustomer = Loadable({
    loader: () => import('../../customer/components/pages/UpdateCustomer')
})
const AsyncCustomerInfo = Loadable({
    loader: () => import('../../customer/components/pages/CustomerInfo')
})

//CONTACT
const AsyncAllContact = Loadable({
    loader: () => import('../../contact/components/pages/AllContact')
})
const AsyncCreateContact = Loadable({
    loader: () => import('../../contact/components/pages/CreateContact')
})
const AsyncUpdateContact = Loadable({
    loader: () => import('../../contact/components/pages/UpdateContact')
})
const AsyncContactInfo = Loadable({
    loader: () => import('../../contact/components/pages/ContactInfo')
})

//PRODUCT
const AsyncAllProduct = Loadable({
    loader: () => import('../../product/components/pages/AllProduct')
})
const AsyncCreateProduct = Loadable({
    loader: () => import('../../product/components/pages/CreateProduct')
})
const AsyncUpdateProduct = Loadable({
    loader: () => import('../../product/components/pages/UpdateProduct')
})
const AsyncProductInfo = Loadable({
    loader: () => import('../../product/components/pages/ProductInfo')
})

//PROFILE
const AsyncAllProfile = Loadable({
    loader: () => import('../../profile/components/pages/AllProfile')
})
const AsyncCreateProfile = Loadable({
    loader: () => import('../../profile/components/pages/CreateProfile')
})
const AsyncUpdateProfile = Loadable({
    loader: () => import('../../profile/components/pages/UpdateProfile')
})
const AsyncProfileInfo = Loadable({
    loader: () => import('../../profile/components/pages/ProfileInfo')
})

//USER
const AsyncAllUser = Loadable({
    loader: () => import('../../user/components/pages/AllUser')
})
const AsyncCreateUser = Loadable({
    loader: () => import('../../user/components/pages/CreateUser')
})
const AsyncUpdateUser = Loadable({
    loader: () => import('../../user/components/pages/UpdateUser')
})
const AsyncUserInfo = Loadable({
    loader: () => import('../../user/components/pages/UserInfo')
})

//DEVICE
const AsyncAllDevice = Loadable({
    loader: () => import('../../device/components/pages/AllDevice')
})
const AsyncCreateDevice = Loadable({
    loader: () => import('../../device/components/pages/CreateDevice')
})
const AsyncUpdateDevice = Loadable({
    loader: () => import('../../device/components/pages/UpdateDevice')
})
const AsyncDeviceInfo = Loadable({
    loader: () => import('../../device/components/pages/DeviceInfo')
})

//IOTAccessory
const AsyncAllIOTAccessory = Loadable({
    loader: () => import('../../iotaccessory/components/pages/AllIOTAccessory')
})
const AsyncCreateIOTAccessory = Loadable({
    loader: () => import('../../iotaccessory/components/pages/CreateIOTAccessory')
})
const AsyncUpdateIOTAccessory = Loadable({
    loader: () => import('../../iotaccessory/components/pages/UpdateIOTAccessory')
})
const AsyncIOTAccessoryInfo = Loadable({
    loader: () => import('../../iotaccessory/components/pages/IOTAccessoryInfo')
})


// const AsyncHome = Loadable({
//     loader: () => import('./Pages/CustomPage')
// })


export default () => (
    <Switch>
        {/* New rout */}
        {/* <Route path='/' component={AsyncHome} /> */}

        {/* Old rout */}
        <PrivateRoute exact path='/' component={AsyncHome} />
        <PublicRoute path='/login' component={AsyncLogin} />
        <PublicRoute path='/noaccess' component={AsyncNoPer} />

        <PrivateRoute path='/customer' component={AsyncAllCustomer} />
        <PrivateRoute path='/customer_create' component={AsyncCreateCustomer} />
        <PrivateRoute path='/customer_update/:id' component={AsyncUpdateCustomer} />
        <PrivateRoute path='/customer_info/:id' component={AsyncCustomerInfo} />

        <PrivateRoute path='/contact' component={AsyncAllContact} />
        <PrivateRoute path='/contact_create' component={AsyncCreateContact} />
        <PrivateRoute path='/contact_update/:id' component={AsyncUpdateContact} />
        <PrivateRoute path='/contact_info/:id' component={AsyncContactInfo} />

        <PrivateRoute path='/product' component={AsyncAllProduct} />
        <PrivateRoute path='/product_create' component={AsyncCreateProduct} />
        <PrivateRoute path='/product_update/:id' component={AsyncUpdateProduct} />
        <PrivateRoute path='/product_info/:id' component={AsyncProductInfo} />

        <PrivateRoute path='/profile' component={AsyncAllProfile} />
        <PrivateRoute path='/profile_create' component={AsyncCreateProfile} />
        <PrivateRoute path='/profile_update/:id' component={AsyncUpdateProfile} />
        <PrivateRoute path='/profile_info/:id' component={AsyncProfileInfo} />

        <PrivateRoute path='/user' component={AsyncAllUser} />
        <PrivateRoute path='/user_create' component={AsyncCreateUser} />
        <PrivateRoute path='/user_update/:id' component={AsyncUpdateUser} />
        <PrivateRoute path='/user_info/:id' component={AsyncUserInfo} />

        <PrivateRoute path='/device' component={AsyncAllDevice} />
        <PrivateRoute path='/device_create' component={AsyncCreateDevice} />
        <PrivateRoute path='/device_update/:id' component={AsyncUpdateDevice} />
        <PrivateRoute path='/device_info/:id' component={AsyncDeviceInfo} />

        <PrivateRoute path='/iotaccessory' component={AsyncAllIOTAccessory} />
        <PrivateRoute path='/iotaccessory_create' component={AsyncCreateIOTAccessory} />
        <PrivateRoute path='/iotaccessory_update/:id' component={AsyncUpdateIOTAccessory} />
        <PrivateRoute path='/iotaccessory_info/:id' component={AsyncIOTAccessoryInfo} />

        <PrivateRoute component={AsyncNotFound} />
    </Switch>
)


// WEBPACK FOOTER //
// ./src/features/ui/components/Routes.js